import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
  }

  * {
    box-sizing: border-box;
    font-family: 'Atma', Courier, monospace;
  }
`;

export default GlobalStyle;